import Button from 'components/Button';
import Overlay from 'components/Layout/Overlay';
import LinkButton from 'components/LinkButton';
import Truncator from 'components/Truncator';
import useOutsideDetector from 'hooks/useOutsideDetector';
import {FC, RefObject, useRef} from 'react';
import {useTranslation} from 'react-i18next';

interface UserListPopupProps {
    canEdit: boolean;
    clientUsers: string[];
    partnerName: string;
    portalMid: string;
    refHeading: RefObject<HTMLSpanElement>;
    refLink: RefObject<HTMLSpanElement>;
    setShow: (show: boolean) => void;
    show: boolean;
}

const UserListPopup: FC<UserListPopupProps> = ({
    canEdit,
    clientUsers,
    partnerName,
    portalMid,
    refHeading,
    refLink,
    setShow,
    show,
}) => {
    const {t} = useTranslation('Portal');

    const refPopup = useRef<HTMLDivElement>(null);
    useOutsideDetector([refPopup, refLink], () => setShow(false));

    if (!show) return null;

    return (
        <Overlay
            aria-label="dropdown-overlay"
            aria-labelledby="userListModalHeading"
            className="border border-grey-300 bg-dark-primary p-6 shadow-md"
            element={refHeading.current}
            layoutLayer="z-dropdown"
            layoutMethod="left-corner"
            layoutOffset={10}
            matchWidth={false}
            role="dialog"
        >
            <div
                className="pointer-events-auto flex w-96 flex-col gap-y-6 text-base"
                ref={refPopup}
            >
                <Button
                    className="absolute right-6 top-6"
                    icon="close"
                    kind="tertiary"
                    onClick={() => setShow(false)}
                    size="xs"
                />
                <div id="userListModalHeading">
                    {t('clientInbox.userListPopup.heading')}
                </div>
                <ul className="my-0">
                    {clientUsers.map((user) => (
                        <li key={user}>
                            <Truncator
                                className="inline-block w-full"
                                text={user}
                                truncateAt="middle"
                            />
                        </li>
                    ))}
                </ul>
                <div>
                    {canEdit ? (
                        <div className="flex flex-row">
                            <LinkButton
                                aria-label="edit"
                                className="mt-1"
                                href={`/portal/${portalMid}/client-inbox/users/edit`}
                                icon="edit"
                                kind="primary"
                                size="sm"
                            >
                                {t('edit')}
                            </LinkButton>
                        </div>
                    ) : (
                        <>
                            {' '}
                            {t('clientInbox.userListPopup.footer', {
                                partnerName,
                            })}{' '}
                        </>
                    )}
                </div>
            </div>
        </Overlay>
    );
};

export default UserListPopup;
